import React from "react";
import Select from "../common/Select";

function SCTFCReferral({ data, handleChange, handleSave }) {
  return (
    <>
      <div className="row">
        <div className="col-4">
          <Select
            name="levelOfPlacement"
            label="Level of Placement requested by DSS"
            onChange={handleChange}
            value={data.DynamicFields.results.levelOfPlacement}
            options={[
              {
                name: "Therapeutic Foster Care 1",
                _id: "TherapeuticFosterCare1",
              },
              {
                name: "Therapeutic Foster Care 2",
                _id: "TherapeuticFosterCare2",
              },
              {
                name: "Therapeutic Foster Care 3",
                _id: "TherapeuticFosterCare3",
              },
              { name: "Special Needs 1", _id: "SpecialNeeds1" },
              { name: "Special Needs 2", _id: "SpecialNeeds2" },
              { name: "Special Needs 3", _id: "SpecialNeeds3" },
              { name: "Medically Fragile 1", _id: "MedicallyFragile1" },
              { name: "Medically Fragile 2", _id: "MedicallyFragile2" },
              { name: "Medically Fragile 3", _id: "MedicallyFragile3" },
              { name: "RFC Non-Therapeutic", _id: "RFCNonTherapeutic" },
              { name: "Other", _id: "Other" },
            ]}
          />
        </div>
      </div>
      <button className="btn btn-primary ms-2" onClick={() => handleSave()}>
        Save Referral
      </button>
    </>
  );
}

export default SCTFCReferral;
